import styled from 'styled-components';

import * as Common from '../../Styles';
import * as MUIIcon from '@mui/icons-material';

const Theme = Common.Theme;

export const ProcessingIcon = styled(MUIIcon.Sync)`
	font-size: 16px !important;
	padding: 5px !important;
`;

export const AddIcon = styled(MUIIcon.PlaylistAddOutlined)`
	font-size: 16px !important;
	padding: 5px !important;
`;

export const ItemStatusIcon = styled(MUIIcon.Beenhere)`
	font-size: 16px !important;
`;

export const IndexStatusIcon = styled(MUIIcon.Business)`
	font-size: 16px !important;
`;

export const StockStatusIcon = styled(MUIIcon.ListAlt)`
	font-size: 16px !important;
`;

export const ArrowDownIcon = styled(MUIIcon.KeyboardArrowDown)`
	font-size: 16px !important;
	color: ${Theme.green} !important;
	vertical-align: middle !important;
	margin-left: auto;
`;

export const StockStatusDropdownIcon = styled(MUIIcon.KeyboardArrowDown)`
	font-size: 16px !important;
	vertical-align: middle !important;
	margin-left: auto;
`;

export const EditIcon = styled(MUIIcon.Edit)`
	font-size: 16px !important;
`;

export const CloneIcon = styled(MUIIcon.FileCopyOutlined)`
	font-size: 16px !important;
`;

export const TrashIcon = styled(MUIIcon.Delete)`
	font-size: 16px !important;
`;

export const RemoveImageIcon = styled(MUIIcon.RemoveCircle)`
	font-size: 16px !important;
	position: absolute;
	top: -7.5px;
	right: -7.5px;
	color: ${Theme.red} !important;
	background: ${Theme.white} !important;
`;

export const PlusIcon = styled(MUIIcon.Add)`
	font-size: 16px !important;
	color: ${Theme.white} !important;
`;

export const ChangeIcon = styled(MUIIcon.Loop)`
	font-size: 16px !important;
`;

export const DownloadIcon = styled(MUIIcon.SystemUpdateAlt)`
	font-size: 16px !important;
	padding: 5px !important;
`;

export const PhotoIcon = styled(MUIIcon.InsertPhotoOutlined)`
	font-size: 20px !important;
`;

export const CrossIcon = styled(MUIIcon.RemoveCircle)`
	color: ${Theme.red} !important;
	font-size: 16px;
	position: absolute;
	right: -8px;
	top: -8px;
	opacity: 100;
`;

export const CloseIcon = styled(MUIIcon.Close)`
	color: ${Theme.red} !important;
	font-size: 16px !important;
`;

export const CheckIcon = styled(MUIIcon.CheckCircle)`
	font-size: 16px;
	color: ${Theme.blue};
	margin: 0 10px 0 auto;
`;

export const ResetIcon = styled(MUIIcon.Cancel)``;

export const NavigationIcon = styled(MUIIcon.KeyboardArrowRight)`
	font-size: 16px !important;
	color: ${Theme.blue} !important;
	vertical-align: middle !important;
	margin: 0 0.25rem 2px 0.25rem !important;
`;

export const CopyIcon = styled(MUIIcon.CopyAll)`
	font-size: 16px !important;
	color: ${Theme.darkGrey} !important;

	&:hover {
		color: ${Theme.secondary} !important;
	}
`;

export const RefreshInventoryIcon = styled(MUIIcon.Sync)`
	font-size: 16px !important;
	color: ${Theme.white} !important;
`;